"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteAnswerResultFromJSON = VoteAnswerResultFromJSON;
exports.VoteAnswerResultFromJSONTyped = VoteAnswerResultFromJSONTyped;
exports.VoteAnswerResultToJSON = VoteAnswerResultToJSON;
exports.VoteAnswerResultToJSONTyped = VoteAnswerResultToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function VoteAnswerResultFromJSON(json) {
    return VoteAnswerResultFromJSONTyped(json, false);
}
function VoteAnswerResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'answer': !(0, runtime_1.exists)(json, 'answer') ? undefined : json['answer'],
        'counter': !(0, runtime_1.exists)(json, 'counter') ? undefined : json['counter'],
        'imageUrls': !(0, runtime_1.exists)(json, 'imageUrls') ? undefined : (0, _1.ImageUrlsFromJSON)(json['imageUrls']),
    };
}
function VoteAnswerResultToJSON(value) {
    return VoteAnswerResultToJSONTyped(value, false);
}
function VoteAnswerResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'answer': value.answer,
        'counter': value.counter,
        'imageUrls': (0, _1.ImageUrlsToJSON)(value.imageUrls),
    };
}
